module.exports = __webpack_public_path__ + "img/dashboard.b52fd61a.svg";